<template>
  <div id="home">
    <Banner />

    <Gallery />

    <Welcome />

    <Accolades />

    <Prices />

    <About />

    <Contact />

    <Testimonials />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Home",
  components: {
    About: () => import("../components/About"),
    Accolades: () => import("../components/Accolades"),
    Banner: () => import("../components/Banner"),
    Contact: () => import("../components/Contact"),
    Gallery: () => import("../components/Gallery"),
    Prices: () => import("../components/Prices"),
    Testimonials: () => import("../components/Testimonials"),
    Welcome: () => import("../components/Welcome"),
  },
  computed: {
    ...mapState(["applicationName"]),
  },
};
</script>
